import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=14a36072&scoped=true"
import script from "./ArticleList.vue?vue&type=script&lang=js"
export * from "./ArticleList.vue?vue&type=script&lang=js"
import style0 from "./ArticleList.vue?vue&type=style&index=0&id=14a36072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a36072",
  null
  
)

export default component.exports